export default __webpack_public_path__ + "static/media/98-14_header_invoice.7a377696.png";